/**
 * Meet our teachers carousel - Swiper.js Implementation
 * Centered carousel with slide effect and custom scaling
 */

var meetOurTeachersSwiper = null;

function initMeetOurTeachersSwiper() {
  const swiperContainer = document.querySelector('.meet-our-teachers__swiper');

  if (!swiperContainer || typeof Swiper === 'undefined') {
    if (swiperContainer && typeof Swiper === 'undefined') {
      setTimeout(initMeetOurTeachersSwiper, 100);
    }
    return;
  }

  // Destroy existing instance before reinitializing
  if (meetOurTeachersSwiper) {
    meetOurTeachersSwiper.destroy(true, true);
    meetOurTeachersSwiper = null;
  }

  const cardsPerView = 4.5;

  meetOurTeachersSwiper = new Swiper('.meet-our-teachers__swiper', {
    effect: 'slide',
    grabCursor: true,
    centeredSlides: true,
    loop: true,
    loopAdditionalSlides: 2,

    slidesPerView: 5,
    spaceBetween: 20,

    speed: 500,

    navigation: {
      nextEl: '.meet-our-teachers__swiper .swiper-button-next',
      prevEl: '.meet-our-teachers__swiper .swiper-button-prev',
    },

    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },

    watchSlidesProgress: true,

    breakpoints: {
      0: {
        slidesPerView: 0.9,
        spaceBetween: 10,
      },
      480: {
        slidesPerView: 1.8,
        spaceBetween: 15,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: cardsPerView,
        spaceBetween: 20,
      },
    },

    a11y: {
      prevSlideMessage: 'Previous teacher',
      nextSlideMessage: 'Next teacher',
    },
  });
}

document.addEventListener('DOMContentLoaded', initMeetOurTeachersSwiper);

// Reinitialize in Shopify theme editor to prevent image blowup on block edits
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', initMeetOurTeachersSwiper);
  document.addEventListener('shopify:section:reorder', initMeetOurTeachersSwiper);
  document.addEventListener('shopify:block:select', initMeetOurTeachersSwiper);
  document.addEventListener('shopify:block:deselect', initMeetOurTeachersSwiper);
}